export type FollowedCommunity = {
  communityId: number;
  logoImageHash: string;
  name: string;
  slug: string;
};

export type CurrentUser = {
  avatarImageUrl: string;
  dateCreated: string;
  followedCommunities: FollowedCommunity[];
  locale: string;
  permissions: string[];
  roles: string[];
  userId: number;
  userImageHash: string;
  username: string;
  unverifiedEmail?: string;
};

export type Member = {
  age: number;
  bio: string;
  country: string;
  gender: string;
  healthInterests: {name: string}[];
  username: string;
};

export type CommunityMember = Member & {
  avatar: string;
  avatarMedium: string;
  id: number;
  profileImageSmall2x: string;
  roles: string[];
  userId: number;
};

export type ExtendedMember = Member & {
  profileImageHash?: string;
  profileImageSmall2x?: string;
  roles?: string[];
}

export enum Role {
  HealthUnlocked = 'HealthUnlocked',
  Partner = 'Partner',
  Administrator = 'Administrator',
  Moderator = 'Moderator',
}

export type NotificationPreference = {
  notificationId: number;
  enabled: boolean;
}
